import styles from "./BpsTabs.module.scss";

export type BpsTab = {
	id: string;
	label: string;
};

interface BpsTabsProps {
	tabs: BpsTab[];
	activeTabId: string;
	onTabChange: (id: string) => void;
}

/** Underlined tab strip of the BPS admin screens. */
export function BpsTabs({ tabs, activeTabId, onTabChange }: Readonly<BpsTabsProps>) {
	return (
		<div className={styles.tabs} role="tablist">
			{tabs.map(tab => (
				<button
					key={tab.id}
					type="button"
					role="tab"
					aria-selected={tab.id === activeTabId}
					className={`${styles.tab} ${tab.id === activeTabId ? styles.active : ""}`}
					onClick={() => onTabChange(tab.id)}
				>
					{tab.label}
				</button>
			))}
		</div>
	);
}
